import { render, staticRenderFns } from "./RangeInput.vue?vue&type=template&id=489391fb&scoped=true&"
import script from "./RangeInput.vue?vue&type=script&lang=js&"
export * from "./RangeInput.vue?vue&type=script&lang=js&"
import style0 from "./RangeInput.vue?vue&type=style&index=0&id=489391fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489391fb",
  null
  
)

export default component.exports